export default {
  'app.pwa.offline': 'Bạn đang offline',
  'app.pwa.serviceworker.updated': 'Có nội dung mới',
  'app.pwa.serviceworker.updated.hint': 'Vui lòng nhấn nút "Làm mới" để tải lại trang',
  'app.pwa.serviceworker.updated.ok': 'Làm mới',
};
